/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApiCategoryList, Pagination } from '../../data/interfaces'
import {
    FETCH_API_CATEGORY_REQUEST, FETCH_API_CATEGORY_SUCCESS, FETCH_API_CATEGORY_FAILURE, CategoryActions
} from '../types/categories'

interface CategoriesState {
    loading: boolean,
    categoryList: ApiCategoryList,
    error: string,
}

const initialState: CategoriesState = {
    loading: true,
    categoryList: { count: 0, list: [] },
    error: ''
}

const apiCategoriesReducer = (state = initialState, action: CategoryActions) => {
    switch (action.type) {
        case FETCH_API_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }
        case FETCH_API_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                categoryList: action.payload,
                error: ''
            }
        case FETCH_API_CATEGORY_FAILURE:
            return {
                ...state,
                loading: false,
                categoryList: { count: 0, list: [] },
                error: action.payload
            }
        default: return state
    }
}

export default apiCategoriesReducer;
